import React, { forwardRef } from "react";

// Fixed 1080x1920 (9:16) share card. Rendered at natural size for html2canvas capture,
// displayed via a scaled wrapper in the parent.
const CardCanvas = forwardRef(function CardCanvas({ result, image }, ref) {
  const ch = result.character;
  const shareTag = result.analysis?.share_tagline || ch.tagline;

  return (
    <div
      ref={ref}
      style={{
        width: 1080, height: 1920, position: "relative", overflow: "hidden",
        background: "linear-gradient(160deg, #0B0F19 0%, #111827 55%, #0B0F19 100%)",
        fontFamily: "'Plus Jakarta Sans', sans-serif", color: "#F9FAFB",
      }}
    >
      {/* ambient glows */}
      <div style={{ position: "absolute", top: -200, right: -150, width: 700, height: 700, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(229,193,88,0.22), transparent 60%)" }} />
      <div style={{ position: "absolute", bottom: -250, left: -200, width: 700, height: 700, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(59,130,246,0.12), transparent 60%)" }} />

      {/* header */}
      <div style={{ position: "absolute", top: 90, left: 0, right: 0, textAlign: "center" }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 52, letterSpacing: 8, fontWeight: 600 }}>
          RUANG <span style={{ color: "#E5C158" }}>KENDALI</span>
        </div>
        <div style={{ marginTop: 24, fontSize: 30, color: "#9CA3AF" }}>"Karakter gue ternyata..."</div>
      </div>

      {/* visual */}
      <div style={{
        position: "absolute", top: 300, left: 90, right: 90, height: 820, borderRadius: 40, overflow: "hidden",
        border: "2px solid rgba(229,193,88,0.35)",
        background: image ? "#0B0F19" : "linear-gradient(145deg, rgba(229,193,88,0.25), #111827)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        {image ? (
          <img src={image} alt={ch.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 260, lineHeight: 1 }}>{ch.icon}</div>
          </div>
        )}
        {/* compatibility badge */}
        <div style={{
          position: "absolute", top: 40, right: 40, background: "rgba(11,15,25,0.85)",
          border: "1px solid rgba(229,193,88,0.5)", borderRadius: 999, padding: "16px 30px",
          fontFamily: "'JetBrains Mono', monospace", fontSize: 34, color: "#E5C158",
        }}>{result.compatibility}% match</div>
      </div>

      {/* character name + tagline */}
      <div style={{ position: "absolute", top: 1180, left: 80, right: 80, textAlign: "center" }}>
        <div style={{ fontSize: 34 }}>{ch.icon}</div>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 108, fontWeight: 700, lineHeight: 1.05,
          color: "#E5C158", marginTop: 10 }}>{ch.name}</div>
        <div style={{ fontSize: 40, color: "#D1D5DB", marginTop: 40, fontStyle: "italic", lineHeight: 1.4 }}>
          "{shareTag}"
        </div>
      </div>

      {/* footer */}
      <div style={{ position: "absolute", bottom: 90, left: 0, right: 0, textAlign: "center" }}>
        <div style={{ width: 120, height: 2, background: "rgba(229,193,88,0.4)", margin: "0 auto 40px" }} />
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 44, letterSpacing: 4, color: "#E5C158" }}>
          Pikir. Hitung. Putuskan.
        </div>
        <div style={{ fontSize: 30, color: "#6B7280", marginTop: 16 }}>ruangkendali.id</div>
      </div>
    </div>
  );
});

export default CardCanvas;
